import TagAlertValue from '@/modules/core/models/TagAlertValue'

export default class TravelConfigurationTags {
  personalDataAlert?: TagAlertValue
  contactDataAlert?: TagAlertValue
  contactDataInsuredAlert?: TagAlertValue
  europeAndMediterraneanCountriesAlert?: TagAlertValue
  allYearAlert?: TagAlertValue
  personalDataInsuredAlert?: TagAlertValue
  allYearPassedDateAlert?: TagAlertValue

  constructor(data: any = {}) {
    if (data.personalDataAlert) this.personalDataAlert = new TagAlertValue(data.personalDataAlert)
    if (data.contactDataAlert) this.contactDataAlert = new TagAlertValue(data.contactDataAlert)
    if (data.europeAndMediterraneanCountriesAlert)
      this.europeAndMediterraneanCountriesAlert = new TagAlertValue(
        data.europeAndMediterraneanCountriesAlert
      )
    if (data.allYearAlert) this.allYearAlert = new TagAlertValue(data.allYearAlert)
    if (data.contactDataInsuredAlert)
      this.contactDataInsuredAlert = new TagAlertValue(data.contactDataInsuredAlert)
    if (data.personalDataInsuredAlert)
      this.personalDataInsuredAlert = new TagAlertValue(data.personalDataInsuredAlert)
    if (data.allYearPassedDateAlert)
      this.allYearPassedDateAlert = new TagAlertValue(data.allYearPassedDateAlert)
  }
}
